import { render, staticRenderFns } from "./myself.vue?vue&type=template&id=d4f2dd1a"
import script from "./myself.vue?vue&type=script&lang=js"
export * from "./myself.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports